<template>
    <b-form-group class="mb-0">
        <label
            v-if="label"
            class="d-block text-gray-dark font-size-4 font-weight-bold float-none"
        >
            <b-row align-v="center">
                <b-col>
                    <div>
                        {{ label }}
                    </div>
                </b-col>

                <b-col cols="3">
                    <b-img
                        :src="require('@assets/images/pay-now-cards.png')"
                        class="ml-auto"
                        fluid
                    />
                </b-col>
            </b-row>
        </label>

        <div
            :class="{ 'is-invalid': isInvalid }"
            class="form-control"
        >
            <div ref="card"/>
        </div>

        <b-form-invalid-feedback :state="!isInvalid">
            {{ invalidFeedback }}
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
    import StripeService from '@services/stripe.service';

    export default {
        name: 'StripeCard',
        props: {
            email: {
                type: String,
                required: true,
            },
            planName: {
                type: String,
                required: true,
            },
            amount: {
                type: Number,
                required: true,
            },
            label: {
                type: String,
            },
        },
        data: () => ({
            stripe: Stripe(window.env.STRIPE_PUBLISHABLE_KEY),
            elements: null,
            card: null,
            isInvalid: false,
            invalidFeedback: '',
        }),
        methods: {
            async sendPayment(isPublic = false) {
                return await this.stripe.createToken(this.card).then(async (result) => {
                    if (result.token) {
                        try {
                            let stripeResponse = await StripeService.sendPayment({
                                token: result.token.id,
                                email: this.email,
                                planName: this.planName,
                                amount: this.amount,
                            }, isPublic);

                            this.isInvalid = false;
                            this.invalidFeedback = '';

                            if (stripeResponse.data?.error) {
                                this.isInvalid = true;
                                this.invalidFeedback = stripeResponse.data.error.message;
                            }

                            return stripeResponse;
                        } catch (error) {
                            this.isInvalid = true;
                            this.invalidFeedback = error.message;

                            throw error;
                        }
                    } else if (result.error) {
                        this.isInvalid = true;
                        this.invalidFeedback = result.error.message;

                        throw new Error(result.error.message);
                    }
                });
            },
        },
        mounted() {
            this.elements = this.stripe.elements();
            this.card = this.elements.create('card');
            this.card.mount(this.$refs.card);
        },
    }
</script>